function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  stroke: "#000",
  strokeWidth: ".7"
}, React.createElement("path", {
  d: "M3.178 11.125a1.305 1.305 0 01.48-1.792l7.13-4.116c.312-.18.86-.265 1.21-.19 0 0 3.825.766 4.15 1.33.326.563-.93 4.276-.93 4.276-.109.336-.452.756-.764.935l-7.129 4.116a1.312 1.312 0 01-1.792-.479l-2.355-4.08z"
}), React.createElement("path", {
  d: "M11.594 9.564c-.592-.497-.65-1.403-.13-2.024.522-.62 1.424-.721 2.017-.224.592.497.65 1.404.13 2.024-.521.621-1.424.721-2.017.224z"
}))));